angular.module 'app'
.controller 'ArticleController', ($scope, $http, $state, $stateParams, $sce, $ionicPopup, config, activeUser) ->
  $scope.ui =
    title: ''
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    userInfo: activeUser.user
    column: {}
    article: {}
    content_html: null

  do findColumn = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/#{$stateParams.column_id}", {}
    .then (res) ->
      $scope.ui.column = res.data
      $scope.ui.title = $scope.ui.column.programa_name
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  do findArticle = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/list/#{$stateParams.article_id}",
      params:
        is_content: true
        programa_id: $stateParams.column_id
        group_id: activeUser.group_id
    .then (res) ->
      $scope.ui.article = res.data
      $scope.ui.article.release_time = moment($scope.ui.article.release_time).format 'YYYY-MM-DD'
      $scope.ui.article.data.content = $scope.ui.article.data.content.replace(/\"http\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\(http\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\&quot;http\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\"https\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\(https\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\&quot;https\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn')
      
      $scope.ui.content_html = $sce.trustAsHtml $scope.ui.article.data.content
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統錯誤！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )
